import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import DashboardAddContent from './components/DashboardAddContent';

const Label = styled.div`
  padding: 16px;
  border-radius: 4px;
  background-color: ${theme.colors.level1};
  &:hover {
    cursor: pointer;
    background-color: ${theme.colors.blue500};
  }
`;

const FullWidthDashboardAddContent = () => (
  <DashboardAddContent
    label={<Label>+ Add Content</Label>}
    placement="top-start"
  />
);

export default FullWidthDashboardAddContent;
